// Chart colors derived from Mantine theme
// Selected for good contrast and visual distinction across different hues
const Colors = [
  'var(--mantine-color-primary-filled)', // #4A1A8A - Dark amethyst
  'var(--mantine-color-info-6)', // #228be6 - Blue
  'var(--mantine-color-accent-5)', // #ff66c4 - Pink
  'var(--mantine-color-success-6)', // #12b886 - Teal
  'var(--mantine-color-primary-5)', // #904DFF - Brand amethyst (lighter)
  'var(--mantine-color-info-9)', // #1864ab - Dark blue
  'var(--mantine-color-accent-7)', // #cc4e9c - Dark pink
  'var(--mantine-color-success-8)', // #099268 - Dark teal
  'var(--mantine-color-primary-3)', // #BEA3FF - Light violet
  'var(--mantine-color-info-4)', // #4dabf7 - Light blue
  'var(--mantine-color-accent-3)', // #ffa5d5 - Light pink
  'var(--mantine-color-success-4)', // #38d9a9 - Light teal
];

export default Colors;
